import React, { Component } from "react";
import _ from "lodash";
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  WithStyles,
  createStyles,
  Typography,
  Grid,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";

import {
  MyPATCollapse,
} from "../../common";
import dateService from "../../common/services/dateService";
import { CheckCircle } from "@material-ui/icons";
import Pagination from "../../common/Pagination";

const styles = (theme: Theme) =>
  createStyles({
    // cards Author and Student
    cardSec: {
      fontFamily: "Nunito",
      backgroundColor: "#fff",
      padding: "12px 0",
      margin: "0",
      cursor: 'pointer',    
      transition: 'all .4s ease-in-out',  
      borderBottom: "1px solid rgba(153, 153, 153, 0.4)",
      '&:nth-last-child(-n+1)':{
        borderBottom: 0,
      },
      '&:hover':{
        backgroundColor: '#f5f5f5',
      },
    },
    profileImg: {
      width: "28px",
      height: "28px",
      borderRadius: "50%",
      fontSize: "16px",
      fontWeight: 600,
      color: "#fff",
      textAlign: "center",
      padding: "3px",
      textTransform: "capitalize",
    },
    purpleColor: {
      background: "#CE9AF6",
    },
    greenColor: {
      background: "#379D0B",
    },
    yellowColor: {
      background: "#F9B159",
    },
    blueColor: {
      background: "#59CCFB",
    },
    redColor: {
      background: "#FE8C8C",
    },
    mt5: {
      marginTop: "5px",
    },
    profileContent:{
      marginLeft: '10px',
      marginRight: 10,
      cursor: 'pointer',
    },
    personName: {
      fontWeight: 600,
      fontSize: "16px",
      lineHeight: "25px",
      color: "#333",
      width: "90px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      display: "inline-block",
      textTransform: "capitalize"
    },
    postTime: {
      fontSize: "16px",
      color: "#666",
      verticalAlign: "top",
      width: "90px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      display: "inline-block",
    },
    postContent: {
      fontSize: "14px",
      lineHeight: "150%",
      color: "#333",
      marginTop: "3px",      
    },
    checkIcon: {
      verticalAlign: "super",
      float: "right",
      color: "#59CA1C;",
      '& svg':{
        width: '1.250em',
        height: '1.250em'
      }
    },
    titleTxt: {
      fontSize: 16,
      fontWeight: 'bold',
    },
    maxHeight: {
      maxHeight: 400,
    },
    customPaginaiton:{
      '&>:first-child':{
        justifyContent: "center"
      }
    }
  });

//@ts-ignore
interface FeedbackPreviewProps extends WithStyles<typeof styles> {
  classes: any;
  feedBackData: any;
  handleFeedbackResolve: Function;
  loadMoreFeedback: Function
}

interface FeedbackPreviewStates {
  isOpenFeedbackPreviewDialog: boolean;
}

class FeedbackPreview extends Component<
  FeedbackPreviewProps,
  FeedbackPreviewStates
> {
  constructor(props: FeedbackPreviewProps) {
    super(props);
    this.state = {
      isOpenFeedbackPreviewDialog: false,
    };
    this.handleFeedbackPreview = this.handleFeedbackPreview.bind(this);
  }

  handleFeedbackPreview(feedback: any) {
    this.props.handleFeedbackResolve(feedback)
  }
  getProfileColor(feedback: any) {
    const { classes } = this.props;
    switch(feedback.topic.user.role){
      case 'evaluator': 
      return [classes.profileImg, classes.greenColor].join(" ")
      case 'creator': 
      return [classes.profileImg, classes.purpleColor].join(" ")
      case 'languageEvaluator': 
      return [classes.profileImg, classes.yellowColor].join(" ")
      case 'moderator': 
      return [classes.profileImg, classes.blueColor].join(" ")
      case 'publisher': 
      return [classes.profileImg, classes.redColor].join(" ")
    }
    
  }
  render() {
    const { classes, feedBackData } = this.props;
    const { isOpenFeedbackPreviewDialog } = this.state;
    return (
      <>
        {/* <MyPATCollapse
          title={
            <Typography className={classes.titleTxt}>
              Feedback <span>{`(${feedBackData && feedBackData.totalCount})`}</span>
            </Typography>
          }
        > */}
          <PerfectScrollbar>
            <Grid container className={classes.maxHeight}>
          {feedBackData &&
            feedBackData.feedbacksData &&
            feedBackData.feedbacksData.map((feedback: any, index: any) => {
              return (
                <Grid container className={classes.cardSec} onClick={()=> this.handleFeedbackPreview(feedback)}>
                  <Grid item xs={1} sm={1}>
                    <Grid
                      className={this.getProfileColor(feedback)}
                    >
                      <span>{index + 1}</span>
                    </Grid>
                  </Grid>
                  <Grid item xs={11} sm={11}>
                    <Grid className={classes.profileContent}>
                      <Typography>
                      <span className={classes.personName}>{feedback.topic.user.role}</span>
                      <span className={classes.postTime}>{dateService.timeSince(feedback.createdAt)}</span>
                      {feedback.isResolved && 
                        <span className={classes.checkIcon}>
                          <CheckCircle />
                        </span>
                       }
                      </Typography>
                      <Typography className={classes.postContent}>
                        {feedback.topic.value}
                      </Typography>
                    </Grid>
                  </Grid>                  
                </Grid>                
              );
            })}
            </Grid>
            </PerfectScrollbar>
            {feedBackData && feedBackData.totalPages > 1 && 
            <Grid container justify="center" className={classes.customPaginaiton}>
              <Pagination 
											onPageChange={this.props.loadMoreFeedback}
											totalPages={feedBackData.totalPages} 
							/>
            </Grid>    
             }        
        {/* </MyPATCollapse> */}
      </>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(FeedbackPreview);
